import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Loader } from '../../../components/loader';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

import { createTreatment, fetchCalculations, showTreatment } from '../../../actions/addTreatments'
import { fetchLeftMedicalRecords } from '../../../actions/medicalRecords';

const $ = window.$;
const initialState = {
    CalculationId: '',
    MedicalRecordId: '',
    start_date: moment().toDate(),
    end_date: moment().toDate(),
    duration: '',
    loading: false,
    treatment: {Calculation: {}, MedicalRecord: {Breed:{}}},
    edit: false,
    calculators: []
}

class ViewTreatment extends React.Component {
    constructor(props) {
        super(props);
    }

    state = initialState;

    submit = (event) => {
        event.preventDefault();
        this.setState({loading: true});
    
        const attr = {
            PetShopId: this.props.petShop.currentPetshop.id,
            CalculationId: this.state.CalculationId,
            MedicalRecordId: this.state.MedicalRecordId,
            start_date: this.state.start_date,
            end_date: this.state.end_date
        }
    
        this.props.createTreatment(attr);
    }

    changeVal = (event) => {
        this.setState({[event.target.name]: event.target.value})
    }

    changeCal = (selected) => {
        this.setState({CalculationId: selected.value});
    }

    changePet = (selected) => {
        this.setState({MedicalRecordId: selected.value})
    }

    changeStartDate = (value) => {
        this.setState({ start_date: value })
    }

    changeEndDate = (value) => {
        this.setState({ end_date: value })
    }

    resetState = () => {
        this.setState(initialState);
        this.props.showTreatment(this.props.treatmentId);
        this.props.fetchCalculations();
    }

    closeModal = () => {
        $('#view_treatment').modal('hide');
        this.resetState();
    }

    submitFormula = (event) => {
        event.preventDefault();
        this.setState({loading: true});
        const attr = {
            PetShopId: this.props.petShop.currentPetshop.id,
            CalculationId: this.state.CalculationId,
            MedicalRecordId: this.state.MedicalRecordId,
            start_date: this.state.start_date,
            end_date: this.state.end_date,
        }

        this.props.createTreatment(attr);

    }

    calculateDosage = (treatment) => {

        let c = treatment.Calculation;
        let dosage = '';

        if(!c) {
            this.closeModal();
            return false;
        }

        if(c.calculationType === 'Formula') {
            dosage = (parseFloat(c.doseMg) / parseFloat(c.strengthMg) * parseFloat(c.strengthMl)) * (parseFloat(treatment.MedicalRecord.weight) / parseFloat(c.doseLb));
            this.setState({dosage: dosage.toFixed(2) + ' ml ', dosageUnit: c.doseTimes + 'x a day', strength: c.strengthMg + 'mg/' + c.strengthMl + 'ml', dose: c.doseMg + 'mg/' + c.doseLb + 'lb ' + c.doseTimes + 'x a day', cType: 'Formula'});
        }
        if(c.calculationType === 'Dosage') {
            dosage = (parseFloat(c.dosageMl)) * (parseFloat(treatment.MedicalRecord.weight) / parseFloat(c.dosageLb));
            this.setState({dosage: dosage.toFixed(2) + ' ml ', dosageUnit: '', dosageR: c.dosageMl + 'ml/' + c.dosageLb + 'lb', cType: 'Dosage'});
        }
        if(c.calculationType === 'Tablet') {
            dosage = (parseFloat(c.doseMg) / parseFloat(c.strengthMg)) * parseFloat(treatment.MedicalRecord.weight);
            if(c.doseType === 'Kg') {
                dosage = dosage * 0.454;
            }
            this.setState({dosage: dosage.toFixed(2) + ' tab ', dosageUnit: c.doseTimes + 'x a day', strength: c.strengthMg + 'mg/tab', dose: c.doseMg + 'mg/' + (c.doseType === 'Lb' ? 'lb ' : 'kg ') + c.doseTimes + 'x a day', cType: 'Tablet'});
        }

        let duration = moment(treatment.end_date).diff(moment(treatment.start_date), 'days') + ' days';
        let daysLeft = parseInt(moment(treatment.end_date).diff(moment(), 'days'));
        
        this.setState({minDuration: c.minDuration, maxDuration: c.maxDuration, duration: duration, daysLeft: daysLeft});
    }

    componentWillReceiveProps = (nextProps) => {

        if(this.props.treatment !== nextProps.treatment) {
            this.setState({treatment: nextProps.treatment});
            this.calculateDosage(nextProps.treatment);
        }

        if(this.props.calculators !== nextProps.calculators && nextProps.calculators.length>0) {
            let options = [];
            nextProps.calculators.map(p => {
              options.push({label: p.treatmentName, value: p.id});
            });
            this.setState({calculators: options});
            this.setState({CalculationId: nextProps.calculators[0].id});
        }
    
    }

    componentDidMount = () => {
        // this.props.showTreatment(this.props.treatmentId);
        this.props.fetchCalculations();
        // this.props.fetchLeftMedicalRecords();
    }

    componentDidUpdate = (prevProps, prevState) => {

        if(prevState.CalculationId !== this.state.CalculationId) {
            this.props.calculators.map(c => {
                if(c.id === this.state.CalculationId)
                    this.setState({duration: c.duration});
            })
        }

        if(prevProps.treatmentId !== this.props.treatmentId) {
            this.props.showTreatment(this.props.treatmentId);
        }
    }

    editInfo = () => {
        this.setState({
            edit: true,
            start_date: moment(this.state.treatment.start_date),
            end_date: this.state.treatment.end_date,
            pet_id: this.state.treatment.pet_id,
        });
        this.state.calculators.map(t => {
            if(t.value === this.state.treatment.Calculation.id) {
                this.setState({CalculationId: t.value});
            }
        })
    }

    render() {
        const {CalculationId, MedicalRecordId, start_date, end_date, calculators, duration, pets, treatment, edit, minDuration, maxDuration, dosageUnit, dosage, cType, strength, dose, dosageR, daysLeft } = this.state;

        return (
            <div className="modal fade show" id="view_treatment" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <form onSubmit={this.submit} className="m-form m-form--label-align-left- m-form--state-">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel" style={{alignSelf: 'center'}}>View Medicating</h5>
                                {/* <a onClick={() => this.editInfo()} className="btn btn-warning m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill mx-2">
                                    <span>
                                        <i className="fas fa-edit"></i>
                                        <span>
                                            Edit
                                        </span>
                                    </span>
                                </a> */}
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-xl-8 offset-xl-2">
                                        <div className="form-group m-form__group row justify-content-center">
                                            <div className="m-portlet col-md-12">
                                                <div className="m-portlet__body  m-portlet__body--no-padding">
                                                    <div className="row m-row--no-padding m-row--col-separator-xl">
                                                        <div className="col-md-6 col-sm-12 widget-border-bottom">
                                                        <div className="m-widget24">
                                                            <div className="m-widget24__item mt-4 mb-4 row">
                                                                <h4 className="m-widget24__title-custom justify-content-center col-md-12">
                                                                    <span className="m-topbar__userpic"><img src={process.env.REACT_APP_S3_PATH + '/' + treatment.MedicalRecord.avatar_path + '/' + treatment.MedicalRecord.avatar_file_name} className="m--img-rounded m-width-58" alt=""/>
                                                                    </span>
                                                                </h4>
                                                            </div>
                                                            <div className="m-widget24__item pb-3 col-md-12 ">
                                                                <div className="row">
                                                                    <div className="col-md-4">
                                                                        <h4 className="m-widget24__title-custom pr-2 justify-content-center">Pet Id:</h4>
                                                                        <h4 className="m-widget24__title-custom px-2 justify-content-center">{treatment.MedicalRecord.pet_id} </h4>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <h4 className="m-widget24__title-custom pr-2 justify-content-center">Weight:</h4>
                                                                        <span className="m-widget24__title-custom m--font-brand justify-content-center">{treatment.MedicalRecord.weight} lb</span>
                                                                    </div>
                                                                    <div className="col-md-5">
                                                                        <h4 className="m-widget24__title-custom pr-2 justify-content-center">Birthday:</h4>
                                                                        <h4 className="m-widget24__title-custom justify-content-center">{treatment.MedicalRecord.date_of_birth}</h4>
                                                                    </div>
                                                                </div>
                                                            </div> 
                                                            <div className="m-widget24__item pb-3 col-md-12" >
                                                                <div className="row px-3">
                                                                    <div className="col-md-4 pt-3 pb-3" style={{borderTop:'1px dotted #c8c8c8'}}>
                                                                        <h4 className="m-widget24__title-custom pr-2 justify-content-center">Gender:</h4>
                                                                        <h4 className="m-widget24__title-custom justify-content-center">{treatment.MedicalRecord.sex} </h4>
                                                                    </div>
                                                                    <div className="col-md-8 pt-3 pb-3" style={{borderTop:'1px dotted #c8c8c8'}}>
                                                                        <h4 className="m-widget24__title-custom pr-2 justify-content-center">Breed:</h4>
                                                                        <h4 className="m-widget24__title-custom justify-content-center">{treatment.MedicalRecord.Breed.breed_type}</h4>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        </div>
                                                        <div className="col-md-6 col-sm-12 widget-border-bottom">
                                                            <div className="m-widget24">
                                                                <div className="m-widget24__item mt-4 mb-4 row">
                                                                    <h4 className="m-widget24__title-custom justify-content-center col-md-12">
                                                                        <i className="la la-tint"></i>
                                                                    </h4>
                                                                </div>
                                                                <div className="m-widget24__item justify-content-center row">
                                                                    <h4 className="m-widget24__title-custom pr-2">
                                                                        Dosage: 
                                                                    </h4>
                                                                    <span className="m-widget24__stats-custom m--font-brand">
                                                                        {dosage}
                                                                    </span>
                                                                </div>
                                                                <div className="m-widget24__item mb-4 row">
                                                                    <h2 className="m-widget24__title-custom dose-times col-md-12">
                                                                        {dosageUnit}
                                                                    </h2>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row m-row--no-padding m-row--col-separator-xl">
                                                        
                                                        <div className="col-md-6 col-sm-12 widget-border-bottom">
                                                            <div className="m-widget24">
                                                                <div className="m-widget24__item mt-4 mb-4 row">
                                                                    <h4 className="m-widget24__title-custom justify-content-center col-md-12">
                                                                        <i className="la la-clock-o"></i>
                                                                    </h4>
                                                                </div>
                                                                <div className="m-widget24__item justify-content-center row">
                                                                    <h4 className="m-widget24__title-custom pr-2">
                                                                        Duration: 
                                                                    </h4>
                                                                    <span className="m-widget24__stats-custom m--font-brand">
                                                                        {duration}
                                                                    </span>
                                                                </div>
                                                                <div className="m-widget24__item justify-content-center dose-times mb-4 row">
                                                                    <h4 className="m-widget24__title-custom pr-2">
                                                                        Recommended: 
                                                                    </h4>
                                                                    <h4 className="m-widget24__title-custom">
                                                                        {minDuration} - {maxDuration} days
                                                                    </h4>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 col-sm-12 widget-border-bottom">
                                                            <div className="m-widget24">
                                                                <div className="m-widget24__item mt-4 mb-4 row">
                                                                    <h4 className="m-widget24__title-custom justify-content-center col-md-12">
                                                                        <i className="la la-medkit"></i>
                                                                    </h4>
                                                                </div>
                                                                <div className="m-widget24__item justify-content-center row pb-3">
                                                                    <h4 className="m-widget24__title-custom font-size-175">
                                                                        {treatment.Calculation.treatmentName} 
                                                                    </h4>
                                                                </div>
                                                                <div className="m-widget24__item justify-content-center row pb-1">
                                                                    <h4 className="m-widget24__title-custom pr-2">
                                                                        {cType === 'Dosage' ? 'Dosage Ratio' : 'Strength'}: 
                                                                    </h4>
                                                                    <span className="m-widget24__title-custom m--font-brand">
                                                                        {cType === 'Dosage' ? dosageR : strength}
                                                                    </span>
                                                                </div>
                                                                {cType !== 'Dosage' &&
                                                                    <div className="m-widget24__item justify-content-center dose-times mb-4 row">
                                                                        <h4 className="m-widget24__title-custom pr-2">
                                                                            Dose: 
                                                                        </h4>
                                                                        <h4 className="m-widget24__title-custom">
                                                                            {dose}
                                                                        </h4>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>                                                        
                                                    </div>
                                                    <div className="row m-row--no-padding m-row--col-separator-xl mb-4">
                                                        <div className="col-md-6 col-sm-12">
                                                            <div className="m-widget24">
                                                                <div className="m-widget24__item justify-content-center row">
                                                                    <h4 className="m-widget24__title-custom pt-4">
                                                                        Start Date: 
                                                                    </h4>
                                                                </div>
                                                                <div className="m-widget24__item row">
                                                                    <h2 className="m-widget24__title-custom dose-times col-md-12">
                                                                        {treatment.start_date}
                                                                    </h2>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 col-sm-12">
                                                            <div className="m-widget24">
                                                                <div className="m-widget24__item justify-content-center row">
                                                                    <h4 className="m-widget24__title-custom pt-4">
                                                                        End Date: 
                                                                    </h4>
                                                                </div>
                                                                <div className="m-widget24__item row">
                                                                    <h2 className="m-widget24__title-custom dose-times col-md-12">
                                                                        {treatment.end_date}
                                                                    </h2>
                                                                </div>
                                                            </div>
                                                        </div>                                                       
                                                    </div>
                                                    {daysLeft > 0 &&
                                                        <div className="row m-row--no-padding m--bg-warning pb-4 mb-4 m-row--col-separator-xl">
                                                            <div className="col-md-12 col-sm-12">
                                                                <div className="m-widget24">
                                                                    <div className="m-widget24__item mt-4 mb-4 row">
                                                                        <h4 className="m-widget24__title-custom justify-content-center col-md-12">
                                                                            <i className="la la-calendar-o"></i>
                                                                        </h4>
                                                                    </div>
                                                                    <div className="m-widget24__item justify-content-center row">
                                                                        <h4 className="m-widget24__title-custom pr-2">
                                                                            Days Left: 
                                                                        </h4>
                                                                        <span className="m-widget24__stats-custom m--font-brand">
                                                                            {daysLeft} days
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="form-group m-form__group row">
                                            
                                <div className="modal-footer">
                                    <button type="submit" className="btn btn-primary m-btn--pill">End</button>
                                </div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                            {edit &&
                                <div className="modal-footer">
                                {this.state.loading == false ?
                                    <div>
                                        <button type="button" className="btn btn-secondary m-btn--pill mx-2" onClick={this.closeModal}>Close</button>
                                        <button type="submit" className="btn btn-primary m-btn--pill">Submit</button>
                                    </div>
                                :
                                    <div className="center-row">
                                        <Loader size={50} />
                                    </div>
                                }
                                </div>
                            }
                            
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}



const mapStateToProps = state => ({
    user: state.cognito.user,
    petShop: state.petShopReducer,
    setTreatments: state.addFormulaReducer.setTreatments,
    calculators: state.addFormulaReducer.calculations,
    pets: state.medicalRecordsReducer.mLeftRecords,
    treatment: state.addFormulaReducer.showTreatment,
});
  
const mapDispatchToProps = dispatch => ({
    fetchCalculations: () => {
        dispatch(fetchCalculations());
    },
    showTreatment: (id) => {
        dispatch(showTreatment(id));
    }
})
  
  
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ViewTreatment));